import moment from 'moment';

export const DOCUMENT_DATE_BEFORE_ADMISSION_MESSAGE =
  'ATENÇÃO: A data do documento não pode ser anterior à data de admissão do colaborador.';

type DateLike = moment.Moment | Date | string | null | undefined;

export interface IDocumentDateValidation {
  isValid: boolean;
  message: string | null;
}

const toStartOfDay = (date: DateLike): moment.Moment | null => {
  if (!date || date === 'null' || date === 'Invalid date') {
    return null;
  }

  const parsedDate = moment(date);

  return parsedDate.isValid() ? parsedDate.startOf('day') : null;
};

/**
 * @param documentDate - Data do documento informada pelo usuário.
 * @param admissionDate - Data de admissão do colaborador (`IEmployee.admissionDate`).
 * @returns Objeto com `isValid` e a `message` a ser exibida quando inválido.
 */
export const validateDocumentDateAgainstAdmission = (
  documentDate: DateLike,
  admissionDate: DateLike,
): IDocumentDateValidation => {
  const document = toStartOfDay(documentDate);

  if (!document) {
    return { isValid: true, message: null };
  }

  const admission = toStartOfDay(admissionDate);

  if (!admission) {
    console.warn(
      'Data de admissão do colaborador não informada. A validação da data do documento contra a admissão não será aplicada.',
    );
    return { isValid: true, message: null };
  }

  if (document.isBefore(admission)) {
    return { isValid: false, message: DOCUMENT_DATE_BEFORE_ADMISSION_MESSAGE };
  }

  return { isValid: true, message: null };
};
